"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.fileUpload = fileUpload;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.to-string.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _getSign = _interopRequireDefault(require("./getSign"));

var _message = require("@/components/dialog/message");

var _index = _interopRequireDefault(require("../../store/index"));

var _stationSetting = require("@/assets/js/stationSetting");

// const getSign = require('./getSign')
// import { VUE_CHANNEL_ID, VUE_UNION_STATION } from "@/assets/js/stationSetting";
var app_id = _stationSetting.VUE_APP_ID;

if (!app_id) {
  app_id = localStorage.getItem("web-id");
} // module.exports = async option => {


var _default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(option) {
    var tempLang, token, req, result, headers, formData, field, arr, _field;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tempLang = localStorage.getItem("language");
            option.data.lang = tempLang || "zh_CN";
            option.data.app_id = app_id;
            option.data.__platform = 3;
            token = window.$.cookie("topcredit_exchange_t") || sessionStorage.getItem("topcredit_exchange_t");
            req = (0, _objectSpread2.default)({
              device_id: _stationSetting.device_id,
              token: token
            }, option.data);
            req._CDCODE = (0, _getSign.default)(req, app_id);
            result = "";
            headers = {}; // 上传图片，添加upload属性

            if (option.upload) {
              formData = new FormData();

              for (field in req) {
                formData.append(field, req[field]);
              }

              result = formData;
            } else {
              headers["content-type"] = "application/x-www-form-urlencoded"; // headers["accept-encoding"] = "gzip,deflate";

              arr = [];

              for (_field in req) {
                arr.push(_field + "=" + req[_field]);
              }

              result = arr.join("&");
            }

            return _context.abrupt("return", function p() {
              return new Promise(function (resolve, reject) {
                window.$.ajax({
                  dataType: option.dataType || "text",
                  type: option.type || "POST",
                  url: option.url,
                  data: result || "",
                  headers: headers,
                  processData: false,
                  contentType: false,
                  success: function success(res) {
                    if (typeof res == "string") {
                      res = JSON.parse(res);

                      if ((res.status == -151516 || res.status == -151515) && _stationSetting.VUE_UNION_STATION == "8V") {
                        _index.default.dispatch("user/v8show");

                        return resolve(res);
                      }

                      if (res.status == -103) {
                        (0, _message.showMessage)({
                          message: "系统当前升级维护中",
                          type: "error",
                          duration: 3000
                        });
                        return;
                      }

                      if (res.status == -105 || res.status == -108) {
                        _index.default.dispatch("user/logout"); // 关闭usdt长连接
                        // window.location.reload();
                        // location.href = "/login";

                      }

                      if (res.status != 200 && res.status != -105) {
                        if (res.msg != "") {
                          (0, _message.showMessage)({
                            message: res.msg
                          });
                        } else {
                          (0, _message.showMessage)({
                            message: "Network error, please try again later",
                            type: "error"
                          });
                        }
                      }
                    }

                    resolve(res);
                  },
                  error: function error(res) {
                    if (typeof res == "string") {
                      res = JSON.parse(res);
                    }

                    (0, _message.showMessage)({
                      message: "Network error, please try again later",
                      type: "error"
                    });
                    reject(res);

                    if (option.retry) {
                      setTimeout(function () {
                        p();
                      }, 5000);
                    }
                  }
                });
              });
            }());

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(); //图片上传


exports.default = _default;

function fileUpload(url, params, error) {
  var config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }; //添加请求头

  return new Promise(function (resolve) {
    axios.post(url, params, config).then(function (res) {
      resolve(res.data);
    }, function (err) {
      err = error ? error : err; // Message.error(err)

      (0, _message.showMessage)({
        message: err,
        type: "error"
      });
    });
  });
}